import React, { useEffect, useState } from 'react'

import _ from 'lodash'
import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import '../../index.scss'
import LtsLookup from './lts-lookup'
import { getFiltroJoinUnidade } from '../../utils/filter-utils'
import { InputText } from 'primereact/inputtext'
import { Dialog } from 'primereact/dialog'
import { LocalizacaoGridListPage } from '../../pages/localizacaoGrid'

export default function LtsLookupLocalizacao(props) {
  const [filters, setFilters] = useState([])
  const [filtroLocalizacaoTemporaria, setFiltroLocalizacaoTemporaria] = useState(false)
  const [filtroUnidade, setFiltroUnidade] = useState('')
  const [displayUILocalizacaoGrid, setDisplayUILocalizacaoGrid] = useState(false)

  useEffect(() => {
    setFiltroUnidade(props.unidade)
  }, [props.unidade, props.showLocalizacaoGrid])

  const columns = [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'identificacao',
      header: 'Identificação',
      columnKey: 'identificacao',
      sortable: true,
      filter: true,
      columnSortField: 'identificacao',
      visible: true,
    },
    {
      field: 'tipoSepultura_descricao',
      header: 'Tipo Sepultura',
      columnKey: 'tipoSepultura_descricao',
      sortable: true,
      filter: true,
      columnSortField: 'tipoSepultura_descricao',
      visible: true,
    },
    {
      field: 'temporaria',
      header: 'Temporária',
      columnKey: 'temporaria',
      sortable: false,
      filter: false,
      columnSortField: 'temporaria',
      visible: false,
    },
    {
      field: 'numeroVagas',
      header: 'Vagas',
      columnKey: 'numeroVagas',
      sortable: true,
      filter: true,
      columnSortField: 'numeroVagas',
      visible: false,
    },
    {
      field: 'numeroLugares',
      header: 'Lugares',
      columnKey: 'numeroLugares',
      sortable: true,
      filter: true,
      columnSortField: 'numeroLugares',
      visible: false,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post(`/lottustech/localizacoes/all`, params)
  }

  const onKeyPress = (e) => {
    const value = _.get(props, 'value', null)
    if (value) {
      const filters = [new Filtro('identificacao', value, 'CONTEM')]
      setFilters(filters)
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({
        oid: '',
        identificacao: value,
      })
    } else {
      props.onChange(value)
    }
  }

  const resolveValue = (data) => {
    const value = _.get(props, 'value', null)
    const oid = _.get(props, 'oidRecord', null)
    if (value) {
      return value
    } else if (oid) {
      return `#${oid} - sem localização`
    }
  }

  const autoCompleteTemplate = (data) => {
    return _.get(data, 'identificacao', null)
  }

  const onResolvingColumn = () => {
    const visibleColumns = columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      // Remove props that should not be spread to DOM elements
      const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

      if (col.field === 'oid') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-oid-body-width"
            filterHeaderClassName="column-oid-filter-header-width"
            headerClassName="column-oid-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      if (col.field === 'identificacao') {
        return (
          <Column
            {...columnProps}
            key={col.field}
            bodyClassName="column-localizacao-body-width"
            filterHeaderClassName="column-localizacao-filter-header-width"
            headerClassName="column-localizacao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }
      return <Column key={col.field} {...columnProps} />
    })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    const newFiltroUnidade = filtroUnidade && filtroUnidade.id ? getFiltroJoinUnidade(filtroUnidade.id) : null
    if (newFiltroUnidade) {
      filters.push(newFiltroUnidade)
    }

    if (props.apenasDisponiveis) {
      filters.push({ campo: 'disponivel', valor: true, tipoFiltro: 'IGUAL_A' })
    }
    return filters
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    if (oid) {
      return `${routes.PATH_LOCALIZACAO}/${oid}`
    }
  }

  const onChangeApenasLocalizacaoTemporaria = (e) => {
    const valor = _.get(e, 'target.checked', false)
    setFiltroLocalizacaoTemporaria(valor)

    const newFilters = filters.filter((f) => f.campo !== 'temporaria')
    if (valor) {
      newFilters.push({ campo: 'temporaria', valor, tipoFiltro: 'IGUAL_A' })
    }
    setFilters(newFilters)
  }

  const onChangeUnidade = (e) => {
    const valor = _.get(e, 'value', null)
    setFiltroUnidade(valor)
    setFilters([]) // para forcar a chamada a 'resolveFilters' pelo componente 'LtsLookup'
  }

  const handleSelectLocalizacaoGrid = (e) => {
    setDisplayUILocalizacaoGrid(false)
    props.onChange(e)
  }

  const showLocalizacaoGrid = () => {
    return (
      <Dialog
        header={_.get(props, 'headerLocalizacaoGrid', 'Localização')}
        visible={displayUILocalizacaoGrid}
        style={{ width: '80vw' }}
        onHide={(e) => setDisplayUILocalizacaoGrid(false)}
        modal={true}
        closable={true}
        baseZIndex={10000000}
        contentStyle={{ maxHeight: '600px', minHeight: '500px', overflow: 'auto' }}
      >
        <React.Fragment>
          <LocalizacaoGridListPage
            renderHeader={false}
            marginTop={'50px'}
            unidadeMemorial={filtroUnidade}
            onClickLocalizacaoSepultamento={handleSelectLocalizacaoGrid}
          ></LocalizacaoGridListPage>
        </React.Fragment>
      </Dialog>
    )
  }

  const handleOnClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (props.showLocalizacaoGrid) {
      setDisplayUILocalizacaoGrid(props.showLocalizacaoGrid)
    }
  }

  const resolveUI = () => {
    return (
      <React.Fragment>
        {showLocalizacaoGrid()}
        <LtsLookup
          label={props.label}
          value={resolveValue()}
          name={props.name}
          field={props.field}
          history={props.history}
          autoCompleteTemplate={autoCompleteTemplate}
          onKeyPress={onKeyPress}
          onInputFilter={onInputFilter}
          pathOnEditFn={pathOnEditFn}
          header={props.header || 'Localização'}
          columns={columns}
          onResolvingColumn={onResolvingColumn}
          loadDataFn={loadDataFn}
          resolveFilters={resolveFilters}
          onChange={props.onChange}
          filters={filters}
          setFilters={setFilters}
          editDisabled={props.editDisabled}
          editHidden={props.editHidden}
          addFiltroDistint={props.addFiltroDistint}
          onChangeTemporaria={onChangeApenasLocalizacaoTemporaria}
          showFiltroTemporaria={props.showFiltroTemporaria}
          apenasTemporaria={filtroLocalizacaoTemporaria}
          disabled={props.disabled}
          unidade={filtroUnidade}
          unidades={props.unidades}
          showFiltroUnidade={props.showFiltroUnidade}
          onChangeUnit={onChangeUnidade} // TODO verificar se nao podemos mover para o componente 'LtsLookup'
          apenasDisponiveis={props.apenasDisponiveis}
          onClick={props.showLocalizacaoGrid ? handleOnClick : null}
        />
      </React.Fragment>
    )
  }
  return resolveUI()
}
